export default __webpack_public_path__ + "img/img_priya-d11ff53b2017442de0c6a2b4cbb5dfed.jpg";